<template>
  <v-container :key="userId">
    <v-container class="ma-0 pa-0 d-flex">
      <h1>Рабочий стол</h1>

      <v-spacer></v-spacer>

      <stat-settings></stat-settings>
    </v-container>

    <months-charts></months-charts>

    <sites-table></sites-table>
  </v-container>
</template>

<script>
import StatSettings from '../components/statistic/StatSettings';
import MonthsCharts from '../components/statistic/MonthsCharts';
import SitesTable from '../components/statistic/SitesTable';

export default {
  components: {
    StatSettings,
    MonthsCharts,
    SitesTable
  },
  created() {
    document.title = 'Рабочий стол';
  },
  computed: {
    userId() {
      return this.$store.state.users.localUser._id;
    }
  }
}
</script>
